import axios from "axios";
import Common from '@/common.js'


const state = {
    session:{},
    profile:{},
    country:{},
    billingAddress:{},
    deliveryAddress:{},
    cart:{},
    cartCount:0
};
const getters = {
    Session: state => state.session,
    Profile: state => state.profile,
    Country: state => state.country,
    BillingAddress: state => state.billingAddress,
    DeliveryAddress: state => state.deliveryAddress,
    Cart: state => state.cart,
    CartCount: state => state.cartCount,
};
const actions = {
    async getSession({commit}){
        var url = Common.getApiCallUrl("Users/UserController::LoginSession");
        const response = await axios.post(url,{},Common.getRequestHeader());
        var data = Common.mapResponse(response.data);
        commit("setSession",data);
   },
   async getCountry({commit}){
    var url = Common.getApiCallUrl("Country/CountryController::Get");
    const response = await axios.post(url,{},Common.getRequestHeader());
    var data = Common.mapResponse(response.data);
    commit("setCountry",data);
    },
   async getBillingAddress({commit}){
        var url = Common.getApiCallUrl("BillingShipping/BillingShippingController::GetBillingAddress");
        const response = await axios.post(url,{},Common.getRequestHeader());
        var data = Common.mapResponse(response.data);
        commit("setBillingAddress",data);
    },
    async getDeliveryAddress({commit}){
        var url = Common.getApiCallUrl("BillingShipping/BillingShippingController::GetShippingAddress");
        const response = await axios.post(url,{},Common.getRequestHeader());
        var data = Common.mapResponse(response.data);
        commit("setDeliveryAddress",data);
    },
    async updateBillingAddress({commit},pdata){
        var config = Common.getRequestHeader();
        var url = Common.getApiCallUrl("BillingShipping/BillingShippingController::UpdateBillingAddress");
        const response = await axios.post(url,pdata,config);
        var data = Common.mapResponse(response.data);
        commit("setBillingAddress",data);
    },
    async updateProfile({commit},pdata){
        var config = Common.getRequestHeader();
        var url = Common.getApiCallUrl("Users/UserController::UpdateProfile");
        
        const response = await axios.post(url,pdata,config);
        var data = Common.mapResponse(response.data);

        var rdata = JSON.parse(data);
        if(rdata.profile_status == '1')
        {
            Common.showSuccess("Profile updated successfully!");
        }else
        {
            Common.showError("Profile could not be updated, please try again!");
        }
   
        var url1 = Common.getApiCallUrl("Users/UserController::LoginSession");
        const response1 = await axios.post(url1,{},Common.getRequestHeader());
        var data1 = Common.mapResponse(response1.data)
        commit("setSession",data1);
    },
    async updateDeliveryAddress({commit},pdata){
        var config = Common.getRequestHeader();
        var url = Common.getApiCallUrl("BillingShipping/BillingShippingController::UpdateShippingAddress");
        const response = await axios.post(url,pdata,config);
        var data = Common.mapResponse(response.data)
        commit("setDeliveryAddress",data);
    },
   async logoutSession({commit}){
    var url = Common.getApiCallUrl("Users/UserController::LogoutSession");
    const response = await axios.post(url,{},Common.getRequestHeader());
    var data = Common.mapResponse(response.data)
    commit("setSession",data);
   },
   async loginSession({commit},cred){
    var url = Common.getApiCallUrl("Users/UserController::Login");
    //var config = {headers: {'Content-Type': 'application/json' }};
    var config = Common.getRequestHeader();

    const response = await axios.post(url,cred,config);
    var data = Common.mapResponse(response.data)
    commit("setSession",data);
   },
   async getCart({commit}){
         var url = Common.getApiCallUrl("Cart/CartController::GetCartItems");
         const response = await axios.post(url,{},Common.getRequestHeader());
         var data = Common.mapResponse(response.data)
         commit("setCart",data);
    },
    async removeFromCart({commit},item){
        var config = Common.getRequestHeader();
        //var config = {headers: {'Content-Type': 'multipart/form-data' }};
        
        var url = Common.getApiCallUrl("Cart/CartController::RemoveFromCart");
        //alert(id);
        const response = await axios.post(url,{"pid" :item.id,"size" :item.size},config);
        var data = Common.mapResponse(response.data)
        commit("setCart",data);
   },
   async addToCart({commit},item){
    var config = Common.getRequestHeader();
    //var config = {headers: {'Content-Type': 'multipart/form-data' }};
    var url = Common.getApiCallUrl("Cart/CartController::AddToCart");
  
    const response = await axios.post(url,item,config);
    var data = Common.mapResponse(response.data)
    commit("setCart",data);
}

};
const mutations = {
    setSession:(state, session) => (state.session = JSON.parse(session)),
    setProfile:(state, session) => (state.profile = JSON.parse(session)),
    setCountry:(state, session) => (state.country = JSON.parse(session)),
    setBillingAddress:(state, session) => (state.billingAddress = JSON.parse(session)),
    setDeliveryAddress:(state, session) => (state.deliveryAddress = JSON.parse(session)),
    setCart:(state, session) => (state.cart = JSON.parse(session),state.cartCount = state.cart.length),
};

export default{
    state,
    getters,
    actions,
    mutations
};